import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';

import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import Header from '@components/Header';

import { getSearchSuplier } from '@actions/supplier'

// import './style.scss'

class SearchSupplier extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      searchSupplier: "",
      suppliersFull: [],
      suppliers: [],
      errors: [],
      loadingTable: false,
      lazyParams: {
        first: 0,
        rows: 6,
        page: 0,
      }
    };
  }

  onSearchSupplier = async () => {
    const { getSearchSuplier } = this.props
    const { searchSupplier } = this.state
    const response = await getSearchSuplier(searchSupplier)
    console.log('response', response)
    if (!response?.status) {
      return this.setState({
        suppliersFull: response?.data,
        suppliers: response?.data,
        loadingTable: false,
        lazyParams: { rows: 6, first: 0, page: 0 }
      });
    } 
    return this.setState({
      suppliersFull: [],
      suppliers: [],
      loadingTable: false,
      lazyParams: { rows: 6, first: 0, page: 0 }
    });
  }

  onEditSupplier = (node) => {
    const { history } = this.props
    return history.push({pathname: '/supplier/detail', state: { ...node }})
  }

  onChangeSearchSupplier = ({ target }) => {
    this.setState({ [target.name]: target.value }, this.validateFieldsOnchange(target.name, target.value));
  }

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state;
    if (errors[name] && value) {
      delete errors[name];
      this.setState({ errors });
    }
  };

  loadDataByPage = () => {
    const { lazyParams, suppliersFull } = this.state
    const dataPage = suppliersFull.slice(lazyParams.first, (lazyParams.first + lazyParams.rows))
    this.setState({ suppliers: dataPage })
  }

  onPage = (event) => {
    const { lazyParams } = this.state;
    const _lazyParams = { ...lazyParams, ...event };
    this.setState({ lazyParams: _lazyParams }, this.loadDataByPage);
  };

  columnResponsive = (rowData, detail) => (
    <>
      <span className="p-column-title">{detail.header}</span>
      {rowData[detail.field]}
    </>
  )

  
  templateEdit = (node, detail) => (
    <div>
      <span className="p-column-title">{detail.header}</span>
      <Button
        type="button"
        icon="pi pi-pencil"
        className="p-button-text"
        style={{ marginRight: '.5em' }}
        onClick={() => this.onEditSupplier(node)}
      />
    </div>
  );

  render() {
    const { t, history } = this.props;
    const { loadingPage, errors, searchSupplier, suppliers, suppliersFull, lazyParams, loadingTable } = this.state;

    const isFormFieldValid = (name) => !!errors[name];
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
      </>
    );
    // if (loadingPage) return true
    return (
      <div className="p-fluid p-grid">
        <div className="p-col-12">
          <Header title={t('Proveedores')} rightComponent={rightHeader} />
          <div className="card p-grid">
            <div className="p-col-12 p-field p-d-flex p-ai-center ">
              <label className="p-text-bold p-mr-3">
                {t('Ingresa un texto para poder buscar proveedores')}
              </label>
            </div>
              <div className="p-col-12 p-lg-6">
                <span className="p-float-label p-input-icon-left">
                  <i className="pi pi-user" />
                  <InputText
                    name="searchSupplier"
                    type="text"
                    value={searchSupplier}
                    placeholder={t('Correo, Documento, Razón Social o Nombre del Representante')}
                    onChange={this.onChangeSearchSupplier}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") this.onSearchSupplier()
                    }}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`searchSupplier`),
                    })}
                  />
                </span>
                {getFormErrorMessage(`searchSupplier`)}
              </div>
              <div className="p-col-12 p-lg-2">
                <Button
                  label={t('Buscar')}
                  icon="pi pi-search"
                  className="p-button-raised p-button-text p-button-plain"
                  onClick={() =>
                    this.onSearchSupplier()
                  }
                />
              </div>
          </div>

          <div className="card p-grid">
            <div className="p-col-12 p-mt-2">
              {suppliers.length ? (
                <>
                  <p>{t('Resultados de la búsqueda')}</p>
                  <DataTable
                    value={suppliers}
                    lazy
                    paginator
                    rows={lazyParams.rows}
                    loading={loadingTable}
                    totalRecords={suppliersFull.length}
                    first={lazyParams.first}
                    onPage={this.onPage}
                    className="table-languages"
                  >
                    <Column
                      header={t('Id')}
                      field="id"
                      className="column-action p-text-center-lg"
                      body={this.columnResponsive}
                    />
                    <Column
                      header={t('Nombre')}
                      field="nombre"
                      body={this.columnResponsive}
                    />
                    <Column
                      header={t('Correo')}
                      field="correo"
                      body={this.columnResponsive}
                    />
                    <Column
                      header={t('Razon social')}
                      field="razon_social"
                      body={this.columnResponsive}
                    />
                    <Column
                      header={t('País')}
                      field="pais"
                      body={this.columnResponsive}
                    />
                    <Column
                    header={t('Editar')}
                    body={this.templateEdit}
                    className="column-action p-text-center-lg"
                  />
                  </DataTable>
                </>

              ) : (
                  <div className="p-col-12 not-information">
                    {t('No se encontraron resultados')}
                  </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
  getSearchSuplier
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(SearchSupplier);
